<div class="onboarding-page">
  <div class="page-header text-center">
    <a routerLink="/"><span class="logo"></span></a>
  </div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xs-4 col-md-4 col-lg-4">

        <div class="card shadow-3 rd-3">
          <div class="card-header text-center">

            <h3>{{'LANDING.unsubscribe.title' | translate}}</h3>

          </div>
          <div class="card-body">

            <form (ngSubmit)="confirmUnsubscribe()" *ngIf="!successMsg">
              <app-submit-btn inputClasses="w100 btn-lg" btnCopy="{{'LANDING.unsubscribe.cta' | translate}}" [loading]="loading"
                [hasError]="errorMsg"></app-submit-btn>
            </form>

            
          </div>
          <app-alert [msg]="errorMsg" type="danger"></app-alert>
          <app-alert [msg]="successMsg" type="success"></app-alert>
        </div>


      </div>
    </div>
  </div>

</div>